<idp-page-container>
  <tpl-page-title>入力内容の確認</tpl-page-title>
  @if (state$ | async; as state) {
    <div class="page-content">
      <div class="description">
        入力内容を確認し、内容に間違いが無ければ、「この内容で登録する」を押してください。
        <br />
        <span class="description-attention">※名・メイ(フリガナ)・生年月日・性別は登録後の変更はできません。</span>
      </div>

      <dl class="profile-body">
        <dt>氏名</dt>
        <dd>{{ state.profile.lastName }} {{ state.profile.firstName }}</dd>
        <dt>フリガナ</dt>
        <dd>{{ state.profile.lastNameKana }} {{ state.profile.firstNameKana }}</dd>
        <dt>生年月日</dt>
        <dd>{{ state.profile.birthDate | date: 'yyyy年M月d日' }}</dd>
        <dt>性別</dt>
        <dd>{{ state.profile.gender | gender }}</dd>
        @if (!verifyPhoneNumber) {
          <dt>電話番号</dt>
          <dd>{{ state.contactAddress.phoneNumber | phoneNumber }}</dd>
        }
        <dt>国</dt>
        <dd>{{ state.contactAddress.countryCode | country }}</dd>
        @if (
          state.contactAddress.zipCode ||
          state.contactAddress.prefectureCode ||
          state.contactAddress.city ||
          state.contactAddress.street ||
          state.contactAddress.building
        ) {
          <dt>住所</dt>
          <dd>
            @if (state.contactAddress.zipCode) {
              <div>〒{{ state.contactAddress.zipCode }}</div>
            }
            @if (state.contactAddress.prefectureCode || state.contactAddress.city || state.contactAddress.street) {
              <div>
                <span>{{ state.contactAddress.prefectureCode | prefecture: true }}</span>
                <span>{{ state.contactAddress.city }}</span>
                <span>{{ state.contactAddress.street }}</span>
              </div>
            }
            @if (state.contactAddress.building) {
              <div>{{ state.contactAddress.building }}</div>
            }
          </dd>
        }
      </dl>
      <div class="action">
        <a
          class="button"
          tpl-button
          color="accent"
          width="fixed"
          buttonType="filled"
          icon="arrow-right"
          (click)="registerProfile(state)"
          >この内容で登録する</a
        >
        <button
          class="plain-button size-small"
          tpl-button
          color="basic"
          buttonType="plain"
          width="auto"
          icon="arrow-left"
          iconPosition="left"
          routerLink="/registration/profile"
        >
          登録内容を編集する
        </button>
      </div>
    </div>
  }
</idp-page-container>
